export default __webpack_public_path__ + "static/media/downloadIcon.f20c395b.svg";